<div class="dashboard-tile {{ cssClass }}" (click)="onClick()">
  <div class="dashboard-tile__items-count">
    @if (isLoading) {
      <mat-spinner></mat-spinner>
    } @else {
      <span>{{ applicationsCount }}</span>
    }
  </div>
  <span class="dashboard-tile__title">{{ title }}</span>
</div>
